import React, { Suspense, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Switch } from 'react-router'
import { useDispatch } from 'react-redux'
import { addSensorsAction } from '@/store/actions/example'
import { EXAMPLE_ACTION_TYPE } from '@/store/constants'
import renderRoutes from '@/routes/renderRoutes'
import routes from '@/routes/index'
import { vConsoleFun } from './utils/vconsole'
import ownSensors from '@/utils/sensorsPonint'
import bridgeObj from './utils/bridge'
import { cleanOpenAppDataAction } from './store/actions/sensorsPonint'
import loginModel from './model/login'
const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
const token = window.localStorage.getItem('token')
const sensors = require('sa-sdk-javascript')

// eslint-disable-next-line
function App() {
  const dispatch = useDispatch()
  const urlParams = new URL(window.location.href)
  const pathname = urlParams?.pathname
  const whitePathNameList = ['/home', '/live-room', '/contribute/agreement', '/contribute/list', '/contribute/log', '/contribute', '/contribute-v2/agreement', '/contribute-v2/list', '/contribute-v2/log', '/contribute-v2', '/system/clean', '/active-page/scalpel']

  // 刷新医生审核状态
  const refreshAuthentication = () => {
    let isWhitePathName =  whitePathNameList.some(item => pathname.startsWith(item))
    if (userInfo?.userType === 3 && token && !isWhitePathName) {
      loginModel.getDoctorAuthentication({}).then((res) => {
        const { licenseStatus } = res.datas
        userInfo.licenseStatus = licenseStatus
        licenseStatus === 3 && (userInfo.userRegisterType = 3)
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
      })
    }
  }
  useEffect(() => {
    // 更新用户认证状态
    refreshAuthentication()
    vConsoleFun()
    bridgeObj.callhandler('from', '', () => {
      localStorage.setItem('h5_platform', 'BoaoApp')
    })

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    sensors.init({
      server_url: process.env.REACT_APP_SENSORS,
      // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      is_track_single_page: true,
      use_client_time: true,
      send_type: 'beacon',
      show_log: true,
      /**
       * &使用网页通用渠道添加自定义属性
       * utm_user_type:  分享人类型，下拉：医生/科室/医院/商务
       * utm_user_id: 分享人博鳌
       * IDutm_share_type: 分享类型 页面名称
       * utm_share_id: 类型对应的ID
       */
      source_channel: ['utm_user_type', 'utm_user_id', 'utm_share_type', 'IDutm_share_type', 'utm_share_id'],
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        clickmap: ' default',
        // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
        scroll_notice_map: 'not_collect'
      }
    })
    // 注册公共属性
    sensors.registerPage({
      platform_type: 'H5',
      app_version: '1.20.0'
    })
    // 用于采集 $pageview 事件
    sensors.quick('autoTrack', {})
    sensors.use('PageLeave')
    // dispatch(addSensorsAction(EXAMPLE_ACTION_TYPE.ADD_SENSORS, sensors))
  }, [dispatch])
  // let location = useLocation()
  useEffect(() => {
    console.log(pathname, 'pathname====')
    ownSensors.updateSensors(sensors)
    ownSensors.updateLoaclPath(pathname)
    dispatch(cleanOpenAppDataAction())
    // eslint-disable-next-line
  }, [pathname])
  return (
    <BrowserRouter>
      <Suspense fallback={<div></div>}>
        <Switch>{renderRoutes(routes)}</Switch>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
